var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityBubbleImage } from './entity-bubble-image';
var cls = classNames('entity-stack');
export var EntityStackDefaultProps = {
  items: [],
  displayCount: 3,
  gap: -20,
  variant: 'default'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: ", "; // -2 here is because the outline creates an extra 2 pixels  \n    font-weight: 500;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    ", "\n    \n  "], ["\n    ", ";\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: ", "; // -2 here is because the outline creates an extra 2 pixels  \n    font-weight: 500;\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n\n    ", "\n    \n  "])), theme.TRANSITION('color'), theme.UNIT(3, -2), theme.FONT_SIZE(12), theme.LINE_HEIGHT('heading'), theme.COLOR('text'), function (_a) {
    var variant = _a.variant;
    return variant === 'small' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: 10px;\n      gap: ", ";\n    "], ["\n      font-size: 10px;\n      gap: ", ";\n    "])), theme.UNIT(1.5, -2));
  })
});
var BubblesStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    ", "\n  "], ["\n    display: flex;\n    ", "\n  "])), function (_a) {
    var gap = _a.gap;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      // because the last bubble is pulled, we need to add overall margin to the right to zero it out\n      margin-right: ", "px;\n    "], ["\n      // because the last bubble is pulled, we need to add overall margin to the right to zero it out\n      margin-right: ", "px;\n    "])), -gap);
  })
});
var BubbleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    outline: 2px solid ", ";\n    \n    ", "\n  "], ["\n    ", ";\n    outline: 2px solid ", ";\n    \n    ", "\n  "])), theme.TRANSITION('filter', 'outline-color'), theme.COLOR('bright'), function (_a) {
    var position = _a.position,
      gap = _a.gap;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      margin-right: ", "px;\n      z-index: ", ";\n    "], ["\n      margin-right: ", "px;\n      z-index: ", ";\n    "])), gap, 20 - position);
  })
});
var NamesAndCountStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var ListedNamesStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: inline-flex;\n    align-items: flex-end;\n  "], ["\n    display: inline-flex;\n    align-items: flex-end;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Bubbles: styled.div.attrs(cls.attr('bubbles'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BubblesStyles),
  Bubble: styled(EntityBubbleImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles),
  NamesAndCount: styled.div.attrs(cls.attr('names-and-count'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), NamesAndCountStyles),
  ListedNames: styled.div.attrs(cls.attr('listed-names'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ListedNamesStyles),
  Name: styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), NameStyles)
};
export var EntityStack = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items,
    displayCount = props.displayCount,
    gap = props.gap,
    variant = props.variant;
  var authorCount = items.length > 3 && items.length - displayCount;
  var isDefault = variant === 'default';
  return React.createElement(My.Container, {
    className: cls.name(className),
    variant: variant
  }, React.createElement(My.Bubbles, {
    gap: gap
  }, items.slice(0, displayCount).map(function (entity, index) {
    return React.createElement(My.Bubble, {
      key: "bubble-".concat(index),
      position: index,
      size: variant === 'small' ? 18 : 48,
      gap: gap,
      entity: entity
    });
  })), React.createElement(My.NamesAndCount, null, React.createElement(My.ListedNames, null, isDefault ? items.slice(0, displayCount).map(function (entity, index) {
    return React.createElement(My.Name, {
      key: "name-".concat(index)
    }, entity === null || entity === void 0 ? void 0 : entity.name, index === displayCount - 1 && authorCount > 3 && " + ".concat(authorCount));
  }) : items.length && React.createElement(My.Name, null, "".concat(items.length)))), children);
};
EntityStack.defaultProps = EntityStackDefaultProps;
EntityStack.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;